<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 aarni-font">Privacy Policy</h1>
    </div>
</div>

<section class="py-5 bg-gray-100 aarni-font">
    <div class="container mx-auto px-4">
        <div class="flex justify-center">
            <div class="w-full max-w-7xl">
                <div class="bg-white shadow-lg rounded-lg p-6">
                    <h5 class="text-lg font-semibold">Welcome to ARNI University, Bringing Ambitions to Life.</h5>

                    <p class="mt-2">
                        We are available on the link
                        <a href="https://arni.in/" class="text-blue-400 font-medium"> https://arni.in/ </a>.
                        We refer to ourselves as ‘Website, Us, We,’ and ‘You, Users or Visitors’ are used to refer to an individual, legal entity, or company that accesses or runs our website.
                    </p>

                    <p class="mt-2">
                        Your privacy is of utmost importance to us and we are committed to protecting it. We do not sell, give, share, or transfer any personal or crucial information to a third party.
                        Through this ‘Privacy Policy,’ we outline how we use, collect, and safeguard your personal information when you visit our website or interact with us online.
                        By accessing our website, you agree to the terms of this Privacy Policy.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">Browsing Behavior</h5>
                    <p class="mt-2">
                        We monitor visitors' browsing habits to learn how our sites are being used.
                        To improve user experience, the websites employ Google Analytics to collect anonymous statistics.
                    </p>

                    <p class="mt-2">We can determine the following with the aid of the web operating system:</p>
                    <ul class="list-disc pl-6 mt-2 space-y-1">
                        <li>Your internet service's domain name, such as "abc.com" or "abc.net"</li>
                        <li>Which browser is being used—"Internet Explorer" or "Google Chrome"?</li>
                        <li>Which operating system—Windows, UNIX, or Macintosh—is being used?</li>
                        <li>When you last visited the website, what did you look at or click on, and how did you find us</li>
                        <li>No personal data is kept on file.</li>
                    </ul>

                    <h5 class="text-lg font-semibold mt-4">Information We Collect</h5>
                    <p class="mt-2">
                        To offer a seamless and best user experience, we may collect the following types of information:
                    </p>

                    <ul class="list-disc pl-6 mt-2 space-y-2">
                        <li><span class="font-semibold">Personal Information:</span> Name, email address, phone number, postal address, and other details provided when filling out forms or registering on our website.</li>
                        <li><span class="font-semibold">Usage Data:</span> Information about how you use our website, including IP address, browser type, pages viewed, and time spent on the website.</li>
                        <li><span class="font-semibold">Cookies and Tracking Technologies:</span> Cookies, web beacons, and similar technologies to enhance your browsing experience.</li>
                        <li><span class="font-semibold">Third-party Information:</span> Data from third-party services, such as social media platforms, if you interact with us through those services.</li>
                    </ul>

                    <h5 class="text-lg font-semibold mt-4">How We Use Your Information</h5>
                    <ul class="list-disc pl-6 mt-2 space-y-1">
                        <li>Provide and improve our services.</li>
                        <li>Process inquiries, applications, or requests.</li>
                        <li>Communicate with you regarding updates, promotions, and events.</li>
                        <li>Personalize your experience on our website.</li>
                        <li>Analyze website usage to improve functionality.</li>
                        <li>Ensure compliance with legal obligations.</li>
                    </ul>

                    <h5 class="text-lg font-semibold mt-4">Your Information Is Safe With Us</h5>
                    <p class="mt-2">
                        Your data privacy and security are always our top priority. We use and implement
                        various security measures, including encryption of sensitive data, secure access controls
                        to limit unauthorized access, and regular monitoring of our systems for vulnerabilities.
                    </p>
                    <p class="mt-2 font-semibold">Note: While we strive to protect your information, no transmission over the internet is entirely secure. You share information at your own risk.</p>

                    <h5 class="text-lg font-semibold mt-4">Sharing of Information</h5>
                    <ul class="list-disc pl-6 mt-2 space-y-1">
                        <li>Vendors or contractors who help us manage and improve our website and services.</li>
                        <li>Authorities or regulators if required to comply with legal obligations or protect our rights.</li>
                        <li>Entities involved in a merger, acquisition, or sale of ARNI University’s assets.</li>
                    </ul>

                    <h5 class="text-lg font-semibold mt-4">Cookies Policy</h5>
                    <p class="mt-2">
                        ARNI University websites use essential cookies for interactive use and tracking user activity. Performance-enhancing cookies gather
                        data about browser sessions, preventing repetitive information input.
                    </p>
                    <p class="mt-2 font-semibold">Note: By using our website, you consent to our use of cookies. You can manage your cookie preferences through your browser settings.</p>

                    <h5 class="text-lg font-semibold mt-4">Third-party Links</h5>
                    <p class="mt-2">
                        Our website may contain links to third-party websites. ARNI University is not responsible for the privacy
                        practices or content of these websites. We encourage you to read their privacy policies before sharing your information.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">Updates to This Privacy Policy</h5>
                    <p class="mt-2">
                        We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements.
                        The updated version will be posted on our website with the "Last Updated" date.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">Contact Us</h5>
                    <p class="mt-2">
                        If you have questions or concerns about this Privacy Policy, please contact us:
                    </p>
                    <p class="mt-2">
                        <span class="font-semibold">ARNI University Website:</span>
                        <a href="https://arni.in/" class="text-blue-400 font-medium"> arni.in </a>,
                        <span class="font-semibold">Email:</span>
                        <a href="mailto:info@arniuniversity.edu.in" class="text-blue-400 font-medium"> info@arniuniversity.edu.in </a>,
                        <span class="font-semibold">Phone:</span>
                        <a href="tel:18008918962" class="text-blue-400 font-medium"> 18008918962 </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
